import { render, staticRenderFns } from "./IconMir.vue?vue&type=template&id=02d3fc5d&"
import script from "./IconMir.vue?vue&type=script&lang=js&"
export * from "./IconMir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports